exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"minimize\":true,\"sourceMap\":true}!vue-multiselect/dist/vue-multiselect.min.css"), "");

// module
exports.push([module.id, ".font-16{font-size:16px!important}", "", {"version":3,"sources":["F:/myugfront/src/components/home/upload-docs-modal.vue"],"names":[],"mappings":"AAEA,SACE,wBAA2B,CAC5B","file":"upload-docs-modal.vue","sourcesContent":["\n@import \"~vue-multiselect/dist/vue-multiselect.min.css\";\n.font-16 {\n  font-size: 16px !important;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/upload-docs-modal.vue
// module id = 884
// module chunks = 3